import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class MenuService {
    leftNavMenu = [
        {
            mainMenuName: "Dashboard",
            user_type: ["0"],
            image: "/assets/images/menu/dashboard.svg",
            route: ['/pages/dashboard'],
            class: "DashboardScr",
            id: "",
            href: "",
            haveSubMenu: false,
            isExpanded: false,
            onhover: false,
            isActive: true
        },
        {
            mainMenuName: "Safe Cab",
            user_type: ["0"],
            image: "/assets/images/menu/safe_cab.svg",
            haveSubMenu: true,
            class: "RemainingScr",
            id: "safecab",
            href: "#safecab",
            route: ['/safecab'],
            onhover: false,
            isActive: false,
            isExpanded: false,
            subMenuList: [
                {
                    name: "Finished Trips",
                    user_type: ["0"],
                    class: "RemainingScr pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/finishedScreen'],
                    image: "/assets/images/menu/finished_trips.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Upcoming Trips",
                    user_type: ["0"],
                    class: "RemainingScr pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/remainingScreen'],
                    image: "/assets/images/menu/upcoming_trips.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Master Trips",
                    user_type: ["0"],
                    class: "pl-4",
                    id: "collapseExample",
                    href: "#collapseExample",
                    route: ["/masterTrip"],
                    image: "/assets/images/menu/master_trips.svg",
                    haveSubMenu: true,
                    isExpanded: false,
                    onhover: false,
                    isActive: false,
                    subMenuList: [
                        {
                            name: "User",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/rncusers'],
                            image: "/assets/images/menu/user.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "Trip Master",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/tripmst'],
                            image: "/assets/images/menu/trip_master.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "User Trips",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/scusertrip'],
                            image: "/assets/images/menu/master_trips.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        }
                    ]
                },
                {
                    name: "Alert log",
                    user_type: ["0"],
                    class: "AlertlogScr pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/alertlogScreen'],
                    image: "/assets/images/menu/alert_log.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Trips Upload",
                    user_type: ["0"],
                    class: "UploadScr pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/uploadScreen'],
                    image: "/assets/images/menu/trips_upload.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Trips",
                    user_type: ["4"],
                    class: "pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/vehiclems'],
                    image: "/assets/images/menu/trips.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Attendance",
                    user_type: ["4"],
                    class: "pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/drivertripdt'],
                    image: "/assets/images/menu/attendance.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Upload",
                    user_type: ["4"],
                    class: "pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/uploadScreen'],
                    image: "/assets/images/menu/upload.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Welness",
                    user_type: ["5", "0"],
                    class: "pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/wellness'],
                    image: "/assets/images/menu/wellness.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                }
            ],
        },
        {
            mainMenuName: "VDMS",
            user_type: ["0"],
            image: "/assets/images/menu/VDMS.svg",
            haveSubMenu: true,
            class: "",
            id: "vdms",
            href: "#vdms",
            route: ["/vdms"],
            onhover: false,
            isActive: false,
            isExpanded: false,
            subMenuList: [
                {
                    name: "VDMS Details",
                    user_type: ["0"],
                    class: "pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/vdms'],
                    image: "/assets/images/menu/VDMS_details.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Fuel Cards",
                    user_type: ["0"],
                    class: "pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/fuel-card-details'],
                    image: "/assets/images/menu/fuel_card.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Fuel Card Credit",
                    user_type: ["0"],
                    class: "pl-4",
                    id: "",
                    href: "",
                    route: ['/pages/fuel-card-credit'],
                    image: "/assets/images/menu/fuel_card_credit.svg",
                    haveSubMenu: false,
                    onhover: false,
                    isActive: false
                },
                {
                    name: "Driver Attendance",
                    user_type: ["0"], 
                    class: "DriverTripDtScr pl-4",
                    id: "driverAttendance",
                    href: "#driverAttendance",
                    route: ["/DriverAttendance"],
                    image: "/assets/images/menu/driver_attendance.svg",
                    haveSubMenu: true,
                    onhover: false,
                    isActive: false,
                    isExpanded: false,
                    subMenuList: [
                        {
                            name: "Attendance",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/drivertripdt'],
                            image: "/assets/images/menu/attendance.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "Trips",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/vehiclems'],
                            image: "/assets/images/menu/trips.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        }
                    ]
                },
            ]
        },
        {
            mainMenuName: "Cab Assist",
            user_type: ["0"],
            image: "/assets/images/menu/cab_assist.svg",
            haveSubMenu: true,
            class: "",
            id: "capassist",
            href: "#capassist",
            route: ["/capAssist"],
            onhover: false,
            isActive: false,
            isExpanded: false,
            subMenuList: [
                {
                    name: "Manage Vendor",
                    user_type: ["0"],
                    class: "pl-4",
                    id: "collapseExample_three",
                    href: "#collapseExample_three",
                    route: ["/manageVendor"],
                    image: "/assets/images/menu/manage_vendor.svg",
                    haveSubMenu: true,
                    onhover: false,
                    isActive: false,
                    isExpanded: false,
                    subMenuList: [
                        {
                            name: "Vendor Master",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/vendor_detail'],
                            image: "/assets/images/menu/vendor_master.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "Assign User",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/assign_user'],
                            image: "/assets/images/menu/assign_user.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        }
                    ]
                },
                {
                    name: "Manage Car",
                    user_type: ["0"],
                    class: "pl-4",
                    id: "collapseExample_one",
                    href: "#collapseExample_one",
                    route: ["/manageCar"],
                    image: "/assets/images/menu/manage_car.svg",
                    haveSubMenu: true,
                    onhover: false,
                    isActive: false,
                    isExpanded: false,
                    subMenuList: [
                        {
                            name: "Car Master",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/rncardata'],
                            image: "/assets/images/menu/car_master.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "Assign Car",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/assign_car'],
                            image: "/assets/images/menu/assign_car.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "Car Request",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/car_maintenance'],
                            image: "/assets/images/menu/car_request.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        }
                    ]
                },
                {
                    name: "Manage House",
                    user_type: ["0"],
                    class: "pl-4",
                    id: "collapseExample_two",
                    href: "#collapseExample_two",
                    route: ["/manageHouse"],
                    image: "/assets/images/menu/manage_house.svg",
                    haveSubMenu: true,
                    onhover: false,
                    isActive: false,
                    isExpanded: false,
                    subMenuList: [
                        {
                            name: "House Master",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/house_master'],
                            image: "/assets/images/menu/house_master.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "House Upload",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/house_upload'],
                            image: "/assets/images/menu/house_upload.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "Assign House",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/assign_house'],
                            image: "/assets/images/menu/assign_house.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "House Request",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/house_req'],
                            image: "/assets/images/menu/house_request.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "House Relocation",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/house_relocation'],
                            image: "/assets/images/menu/house_relocation.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        }
                    ]
                },
                {
                    name: "Manage Driver",
                    user_type: ["0"],
                    class: "pl-4",
                    id: "collapseExample_driver",
                    href: "#collapseExample_driver",
                    route: ["/manageDriver"],
                    image: "/assets/images/menu/manage_driver.svg",
                    haveSubMenu: true,
                    onhover: false,
                    isActive: false,
                    isExpanded: false,
                    subMenuList: [
                        {
                            name: "Config",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/driverconfig'],
                            image: "/assets/images/menu/config.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "Feedback",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/driver_feedback'],
                            image: "/assets/images/menu/feedback.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        },
                        {
                            name: "Concerns",
                            user_type: ["0"],
                            class: "pl-6",
                            id: "",
                            href: "",
                            route: ['/pages/driver_concerns'],
                            image: "/assets/images/menu/concerns.svg",
                            haveSubMenu: false,
                            onhover: false,
                            isActive: false
                        }
                    ]
                }
            ]
        }
    ];
    constructor() { }

    getMenuList() {
        return this.leftNavMenu;
    }
}